module.exports = __webpack_public_path__ + "7fb9d47f0bca3a9c5ccceeae5e071a5b.png";